import { IPaginationParams } from '../../../types';
import { ILprDeviceFilterProps } from '../../../Devices/LprService/types';
import { useQuery } from 'react-query';
import {
  getAllTelegramIdsByLicenseAsync,
  getAllTelegramIdsByLicenseCountAsync,
} from '../../index';
import { ITelegramIdsFilterProps } from '../../types';
import { getUserId } from '../../../DefaultService';

const USER_ID = getUserId();

export const useGetAllTelegramIdsByLicense = (
  pagination?: IPaginationParams,
  filter?: ITelegramIdsFilterProps,
) =>
  useQuery([`telegramIds${pagination?.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllTelegramIdsByLicenseAsync(pagination, filter),
  });

export const useGetAllTelegramIdsByLicenseCount = (
  pagination: IPaginationParams,
  filter: ILprDeviceFilterProps,
) =>
  useQuery([`telegramIdsCount${pagination.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllTelegramIdsByLicenseCountAsync(filter),
  });
